import { SignupNewsletterForm } from '@components/Forms';
import React, { FC, useState } from 'react';

export const FooterSignupNewsletter: FC = () => {
  const [success, setSuccess] = useState<boolean>(false);

  return (
    <div className="flex flex-col">
      <div className="w-full md:w-8/12 lg:w-10/12">
        <h3 className="text-2xl lg:text-3xl mt-0 mb-6">News you can use in your inbox</h3>

        {!success && <SignupNewsletterForm onSuccess={setSuccess} />}
      </div>

      {success ? (
        <p className="mt-6 text-sm font-medium text-ocean-blue leading-5">
          Thanks for signing up, and welcome to the CircleOf community! We care, together.
          <br />
          <br />
          Add <b>hello@circleof.com</b> to your address book to ensure you get our newsletters.{' '}
        </p>
      ) : (
        <p className="mt-6 text-sm font-medium text-ocean-blue leading-5">
          CircleOf is committed to protecting and respecting your privacy. Agreeing to receive our monthly newsletter is consent
          to receive email about our products and services. For information on how to unsubscribe from emails, our privacy
          practices, and how we protect your information
          <a href="/privacy-policy" target="_blank" className="font-bold ml-1 underline">
            click here
          </a>
          .
        </p>
      )}
    </div>
  );
};

export default FooterSignupNewsletter;
